var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_582_3503",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 24,
    height: 24,
    transform: "rotate(90 24 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_582_3503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2246 11.9998L9.32461 8.0998C9.14128 7.91647 9.04961 7.68314 9.04961 7.3998C9.04961 7.11647 9.14128 6.88314 9.32461 6.6998C9.50794 6.51647 9.74128 6.4248 10.0246 6.4248C10.3079 6.4248 10.5413 6.51647 10.7246 6.6998L15.3246 11.2998C15.4246 11.3998 15.4954 11.5081 15.5371 11.6248C15.5788 11.7415 15.5996 11.8665 15.5996 11.9998C15.5996 12.1331 15.5788 12.2581 15.5371 12.3748C15.4954 12.4915 15.4246 12.5998 15.3246 12.6998L10.7246 17.2998C10.5413 17.4831 10.3079 17.5748 10.0246 17.5748C9.74128 17.5748 9.50794 17.4831 9.32461 17.2998C9.14128 17.1165 9.04961 16.8831 9.04961 16.5998C9.04961 16.3165 9.14128 16.0831 9.32461 15.8998L13.2246 11.9998Z",
    fill: "#828282"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.79dbd31af52f9a7ccd7669fce463ed6e.svg";
export { ForwardRef as ReactComponent };